/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import * as PropTypes from "prop-types";
import { Link } from "react-ui";
import { KonturColors } from "@skbkontur/colors";

import { Icon } from "../../../../Icons/Icon";

import { AddressModalContainer as AddressModal } from "./AddressModalContainer";
import type { Address } from "./Types";
import { PlaceDescription } from "./Types";
import * as util from "./util";

const Colors = {
    OK: KonturColors.green100,
    ERROR: KonturColors.red100,
    WARNING: KonturColors.yellow80,
};

export interface KladrValue {
    address: Address;
}

export interface KladrProps {
    error?: string;
    title: string;
    value: any;
    warning?: string;
    onChange?: (event: any, value: KladrValue) => void;
    isReadOnly?: boolean;
    "data-tid"?: string;
}

export interface KladrState {
    opened: boolean;
}

export class Kladr extends React.Component<KladrProps, KladrState> {
    public static __KONTUR_REACT_UI__ = "Kladr";

    public static propTypes = {
        error: PropTypes.string,
        title: PropTypes.string,
        value: PropTypes.any,
        warning: PropTypes.string,
        onChange: PropTypes.func,
    };

    public constructor(props: any) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        super(props);

        this.state = {
            opened: false,
        };
    }

    public render() {
        const value = this.props.value || {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const empty = isEmpty(value);
        const change = empty ? "Заполнить адрес" : "Изменить адрес";

        let validation = null;
        if (this.props.error) {
            validation = <div style={{ color: Colors.ERROR, marginBottom: 5 }}>{this.props.error}</div>;
        } else if (this.props.warning) {
            validation = <div style={{ color: Colors.WARNING, marginBottom: 5 }}>{this.props.warning}</div>;
        }

        return (
            <span>
                {/* eslint-disable-next-line @typescript-eslint/no-unsafe-argument */}
                {!empty && <div style={{ marginBottom: 5 }}>{this.renderAddress(value.address)}</div>}
                {this.props.isReadOnly !== true && validation}
                {this.props.isReadOnly !== true && (
                    <Link
                        icon={<Icon name="ToolPencilLineIcon" />}
                        onClick={this.handleOpen}
                        data-tid={this.props["data-tid"]}>
                        {change}
                    </Link>
                )}
                {this.state.opened && this.renderModal()}
            </span>
        );
    }

    private renderAddress(address?: Address) {
        if (!address) {
            return null;
        }

        const place = (x?: null | PlaceDescription) => x && util.placeName(x);
        return [
            address.index,
            place(address.region),
            place(address.district),
            place(address.city),
            place(address.settlement),
            place(address.street),
            address.house && `дом ${address.house}`,
            address.building && `корпус ${address.building}`,
            address.room && `квартира ${address.room}`,
        ]
            .filter(x => !!x)
            .join(", ");
    }

    private renderModal() {
        return (
            <AddressModal
                address={this.props.value && this.props.value.address}
                title={this.props.title}
                onChange={this.handleChange}
                onClose={this.handleClose}
            />
        );
    }

    private readonly handleOpen = () => {
        this.setState({ opened: true });
    };

    private readonly handleChange = (value: { address: Address }) => {
        const onChange = this.props.onChange;
        onChange && onChange(null, value);
    };

    private readonly handleClose = () => {
        this.setState({ opened: false });
    };
}

function isEmpty(value: KladrValue): boolean {
    const address = value.address;
    if (address) {
        for (const key of Object.keys(address) as Array<keyof Address>) {
            if (address[key]) {
                return false;
            }
        }
    }

    return true;
}
